<template>
  <b-card no-body class="h-100">
    <div class="card-header d-flex align-items-center justify-content-between">
      <h5 class="mb-0">
        <feather-icon icon="ClipboardIcon" size="16" class="mr-50" />
        {{ $t('Associated Maintenance Plan') }}
      </h5>
      <b-button size="sm" variant="primary" @click="$emit('add')">
        <feather-icon icon="PlusIcon" size="14" class="mr-25" />
        {{ $t('Add') }}
      </b-button>
    </div>

    <b-card-body class="p-0">
      <div v-if="loading" class="text-center py-2">
        <b-spinner small variant="primary" />
      </div>

      <div v-else-if="plans.length === 0" class="text-center text-muted py-2 px-1">
        <p class="mb-1">{{ $t('No associated plans') }}</p>
        <b-button size="sm" variant="outline-primary" @click="$emit('add')">
          {{ $t('Associate plan') }}
        </b-button>
      </div>

      <div v-else>
        <b-table
          :items="plans"
          :fields="fields"
          responsive
          hover
          class="mb-0"
          primary-key="id"
        >
          <template #cell(name)="data">
            {{ data.item.name }}
          </template>
          <template #cell(actions)="data">
            <b-button
              variant="flat-danger"
              class="btn-icon"
              v-b-tooltip.hover.top="$t('Remove')"
              @click="$emit('remove', data.item.id, data.item.preventiveMaintenancePlanId)"
            >
              <feather-icon icon="Trash2Icon" size="16" />
            </b-button>
          </template>
        </b-table>

        <div class="px-1 py-1">
          <b-row>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-start">
              <span class="text-muted">
                {{ $t('Showing') }} {{ dataMeta.from }} {{ $t('to') }} {{ dataMeta.to }} {{ $t('of') }} {{ dataMeta.of }} {{ $t('entries') }}
              </span>
            </b-col>
            <b-col cols="12" sm="6" class="d-flex align-items-center justify-content-center justify-content-sm-end">
              <b-pagination
                :value="currentPage"
                :total-rows="totalItems"
                :per-page="perPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
                @input="$emit('update:currentPage', $event)"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </div>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BButton, BCard, BCardBody, BCol, BPagination, BRow, BSpinner, BTable, VBTooltip,
} from 'bootstrap-vue'
import i18n from '@/libs/i18n'

export default {
  name: 'AssociatedPlansCard',
  components: {
    BButton, BCard, BCardBody, BCol, BPagination, BRow, BSpinner, BTable,
  },
  directives: { 'b-tooltip': VBTooltip },
  props: {
    plans: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    currentPage: { type: Number, default: 1 },
    totalItems: { type: Number, default: 0 },
    perPage: { type: Number, default: 10 },
    dataMeta: {
      type: Object,
      default: () => ({ from: 0, to: 0, of: 0 }),
    },
  },
  setup() {
    const fields = [
      { key: 'name', label: i18n.t('Name') },
      { key: 'actions', label: i18n.t('Actions'), class: 'text-right' },
    ]

    return { fields }
  },
}
</script>

<style lang="scss" scoped>
.btn-icon {
  padding: 0.35rem;
}
</style>
